import { render, staticRenderFns } from "./search-category.vue?vue&type=template&id=e85436a0&"
import script from "./search-category.vue?vue&type=script&lang=js&"
export * from "./search-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports